(() => {
  const init = scope => {
    scope.querySelectorAll('.tlf-sample-reviews').forEach(section => {
      if (section.dataset.reviewReady) return;
      section.dataset.reviewReady = 'true';
      const rail = section.querySelector('[data-review-rail]');
      const prev = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      if (!rail || !prev || !next) return;
      const sync = () => {
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 3;
      };
      const move = direction => {
        const card = rail.querySelector('.tlf-review');
        const gap = parseFloat(getComputedStyle(rail).gap) || 0;
        const step = card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
        rail.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', sync, { passive: true });
      new ResizeObserver(sync).observe(rail);
      sync();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
